export default __webpack_public_path__ + "static/media/20A_thumbnail.ba577bf2.JPG";